module.exports = __webpack_public_path__ + "static/img/zf3.29527e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zf3.png
// module id = c/fP
// module chunks = 1